import { defaultPageImagePath } from '@gik/core/constants';
import type { InkindPageAPIModel } from '@gik/core/models/gik/InkindPage';
import type { UIComponent } from '@gik/core/types/UI';
import { useBemCN } from '@gik/core/utils/bemBlock';
import { Avatar } from '@gik/ui/Avatar';
import { HTMLParser } from '@gik/ui/HTMLParser';
import React from 'react';

export type InkindGroupWidgetTileProps = {
  inkindPage: Partial<InkindPageAPIModel>;
  onRemove?(inkindPage: InkindPageAPIModel): void | Promise<void>;
  noToolbar?: boolean;
  row?: boolean;
  showLink?: boolean;
  showTitle?: boolean;
} & UIComponent;

const blockName = 'inkind-group-widget-tile';

export function InkindGroupWidgetTile({
  inkindPage,
  showLink,
  showTitle = true,
}: InkindGroupWidgetTileProps): JSX.Element {
  const bem = useBemCN(blockName);

  return (
    <div {...bem(null, null)}>
      <header {...bem('header')}>
        <Avatar rounded {...bem('image')} imageUrl={inkindPage?.imgSrc || defaultPageImagePath} circle={false} />
      </header>

      <section {...bem('content')}>
        {showTitle && (
          <section {...bem('title')}>
            <HTMLParser
              rawHtml={inkindPage?.title?.length > 75 ? inkindPage?.title?.substr(0, 72) + '...' : inkindPage?.title}
            />
          </section>
        )}
        {showLink && (
          <section {...bem('link-preview')} title={inkindPage?.url}>
            {inkindPage?.url}
          </section>
        )}
      </section>
    </div>
  );
}
